import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {EmpresaService} from "../../services/empresa.service";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";

@Component({
  selector: 'app-form-integracao-99food',
  templateUrl: './form-integracao-99food.component.html',
  styleUrls: ['./form-integracao-99food.component.scss']
})
export class FormIntegracao99FoodComponent implements OnInit {
  @ViewChild('frm', { static: false }) frm: any;
  @Input() empresa: any;
  @Input() integracaoFood99: any;
  @Input() indice = 0;
  @Output() cancelou = new EventEmitter<void>();
  @Output() removeu = new EventEmitter<void>();

  mensagemErro: string;
  gerandoLink = false;
  ativando = false;
  removendo = false;
  salvandoPublicacao = false;
  publicacaoCatalogoHabilitada = false;
  confirmarRemover = false;
  redirecionando = false;
  shopId = '';
  urlAtivacao: string;
  // Método de confirmação de pedidos
  metodosConfirmacao = [
    { value: 1, text: 'App 99 e Meu Cardapio (B-App & OpenAPI)' },
    { value: 2, text: 'Meu Cardapio somente (OpenAPI)' }
  ];
  metodoConfirmacao: any = null;
  salvandoMetodo = false;
  private metodoConfirmacaoAnterior: number = null;
  // Auto switch (abrir/fechar automático)
  autoSwitchOpcoes = [
    { value: 1, text: '1- Abrir Loja Automaticamente' },
    { value: 2, text: '2- Fechar Loja Automaticamente' },
    { value: 3, text: '3- Abrir/Fechar Automaticamente' }
  ];
  autoSwitchSelecionado: any = null;
  salvandoAutoSwitch = false;

  private autoSwitchAnterior: number = null;

  constructor(private empresaService: EmpresaService, public monitoradorPedidos: MonitoradorPedidos) { }

  ngOnInit(): void {
    this.publicacaoCatalogoHabilitada = this.integracaoFood99?.publicacaoCatalogoHabilitada === true;
    if (this.integracaoFood99?.lojasAtivar?.length && !this.integracaoFood99.lojaSelecionada) {
      this.integracaoFood99.lojaSelecionada = this.integracaoFood99.lojasAtivar[0];
    }
    // Atualiza status das lojas 99Food para exibir Abrir/Fechar
    try { this.monitoradorPedidos.autalizeStatus99Food(); } catch (e) {}
    // Valor inicial padrão (quando não disponível no backend)
    this.metodoConfirmacaoAnterior = this.metodoConfirmacao;


    if(this.integracaoFood99 && this.integracaoFood99.ultimoStatus){
      let partesStatus: Array<any> = this.integracaoFood99.ultimoStatus.split(':');

      if(partesStatus.length > 1)
        this.autoSwitchSelecionado = Number(partesStatus[2])

    }

    this.autoSwitchAnterior = this.autoSwitchSelecionado;

  }

  onSubmit(): void { }

  async alterePublicacaoCatalogo(habilitada: boolean): Promise<void> {
    if(this.salvandoPublicacao || !this.integracaoFood99?.id || this.integracaoFood99.desativado) return;
    this.salvandoPublicacao = true;
    this.mensagemErro = '';
    try {
      await this.empresaService.atualizePublicacaoCatalogo99Food(this.integracaoFood99.id, habilitada);
      this.integracaoFood99.publicacaoCatalogoHabilitada = habilitada;
    } catch(erro) {
      this.mensagemErro = erro?.message || String(erro);
    } finally {
      this.salvandoPublicacao = false;
    }
  }

  gereLinkAutorizacao(): boolean {
    if (!this.urlAtivacao) {
      this.gerandoLink = true;
      this.empresaService.gereLinkAtivacao99Food().then((urlAtivacao: any) => {
        this.urlAtivacao = urlAtivacao;
        this.gerandoLink = false;
        this.abraLinkAtivacao();
      }).catch((erro) => {
        this.mensagemErro = erro?.message || erro;
        this.gerandoLink = false;
      });
    } else {
      this.abraLinkAtivacao();
    }
    return false;
  }

  abraLinkAtivacao(): void {
    this.redirecionando = true;
    const janela = window.open(this.urlAtivacao);
    if (!janela) {
      this.mensagemErro = 'Janela bloqueada pelo navegador. Verifique e tente novamente.';
    }
  }

  onAlterouMetodoConfirmacao(): void {
    if (!this.integracaoFood99?.id) return;
    this.salvandoMetodo = true;
    const escolhido = this.metodoConfirmacao;
    this.empresaService.altere99FoodMetodoConfirmacao({ id: this.integracaoFood99.id, metodo: escolhido })
      .then(() => {
        this.salvandoMetodo = false;
        this.metodoConfirmacaoAnterior = escolhido;
      })
      .catch((erro) => {
        this.salvandoMetodo = false;
        this.metodoConfirmacao = this.metodoConfirmacaoAnterior;
        this.mensagemErro = erro?.message || erro;
      });
  }

  apliqueMetodoConfirmacao(): void {
    this.onAlterouMetodoConfirmacao();
  }

  explicacaoMetodo(): string {
    if (this.metodoConfirmacao === 2) {
      return 'Aceitação/Cancelamento serão feitos apenas pelo Meu Cardápio (OpenAPI).';
    }
    if (this.metodoConfirmacao === 1) {
      return 'Pedidos podem ser aceitos/cancelados pelo app 99Food Store ou pelo Meu Cardápio.';
    }
    return '';
  }

  apliqueAutoSwitch(): void {
    this.onAlterouAutoSwitch();
  }

  onAlterouAutoSwitch(): void {
    if (!this.integracaoFood99?.id) return;
    this.salvandoAutoSwitch = true;
    const selecionado = this.autoSwitchSelecionado;

    this.empresaService.altere99FoodStatusAutomatico({ id: this.integracaoFood99.id, autoSwitch: selecionado  })
      .then(() => {
        this.salvandoAutoSwitch = false;
        this.autoSwitchAnterior = selecionado;
      })
      .catch((erro) => {
        this.salvandoAutoSwitch = false;
        this.autoSwitchSelecionado = this.autoSwitchAnterior;
        this.mensagemErro = erro?.message || erro;
      });
  }

  explicacaoAutoSwitch(): string {
    let autoSwitch = typeof this.autoSwitchSelecionado === 'object' ?
      (this.autoSwitchSelecionado as any).value : this.autoSwitchSelecionado
    switch (autoSwitch) {
      case 1: return 'Permitir que a 99Food abra Loja automaticamente (ex.: alta demanda, horário de funcionamento, etc.)';
      case 2: return 'Permitir que a 99Food feche a Loja automaticamente (ex.: falta de entregadores, grandes atrasos, pedidos acumulados)';
      case 3: return 'Permitir que a 99Food abra e/ou feche a Loja automaticamente';
      default: return '';
    }
  }

  ativeLojaSelecionada(): void {
    if (!this.integracaoFood99?.lojaSelecionada) {
      this.mensagemErro = 'Selecione uma loja para continuar';
      return;
    }

    const { id, name } = this.integracaoFood99.lojaSelecionada;
    const integracaoData = {
      idLoja: id,
      nomeLoja: name,
      authId: this.integracaoFood99.authId
    };

    this.autorizeNovaLoja(integracaoData);
  }

  ativeManualmenteLoja(): void {
    if (!this.shopId) {
      this.mensagemErro = 'Informe o ID da loja que deseja integrar';
      return;
    }
    this.autorizeNovaLoja({ shopId: this.shopId });
  }

  autorizeNovaLoja(integracaoData: any): void {
    this.ativando = true;
    this.mensagemErro = null;

    this.empresaService.confirmeIntegracaoLoja99Food(integracaoData).then((integracao: any) => {
      this.ativando = false;
      this.integracaoFood99 = integracao;
      this.integracaoFood99.nova = false;
      this.empresaService.sincronizeFormasPagamento99Food();
      setTimeout(() => window.location.replace('admin/loja/tab/99food'), 1500);
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro?.message || erro;
    });
  }

  alterouAtivarAceitarCancelamento($event: any){
    console.log($event)

    this.empresaService.altere99FoodAceitarCancelamento(this.integracaoFood99).then((integracao: any) => {

    }).catch((erro) => {
      this.integracaoFood99.aceitaCancelamento = !this.integracaoFood99.aceitaCancelamento
      this.mensagemErro = erro?.message || erro;
    });

  }

  alterouAtivarAceitarReembolso($event: any){
    console.log($event)

    this.empresaService.altere99FoodAceitarReembolso(this.integracaoFood99).then((integracao: any) => {

    }).catch((erro) => {

      this.mensagemErro = erro?.message || erro;
    });
  }

  confirmeRemover(): void {
    this.confirmarRemover = true;
  }

  canceleRemover(): void {
    this.confirmarRemover = false;
  }

  removerIntegracao(): void {
    this.removendo = true;
    this.empresaService.removaIntegracao99Food(this.integracaoFood99).then(() => {
      this.removendo = false;
      this.integracaoFood99.removida = true;
      this.integracaoFood99 = null;
      this.removeu.emit();
    }).catch((erro) => {
      this.removendo = false;
      this.mensagemErro = erro?.message || erro;
    });
  }

  fecharAlerta(): void {
    this.mensagemErro = null;
  }

  // Ações de loja (abrir/fechar) e utilitários de status
  abrirLoja99Food(): void {
    if (!this.integracaoFood99) return;
    this.ativando = true;
    this.empresaService.abrirLoja99Food({ id: this.integracaoFood99.id }).then(() => {
      this.ativando = false;
      const info: any = this.infoLoja99Food();
      if (info) info.aberta = true;
      window.setTimeout(() => this.recarregueStatus99Food(), 800);
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro?.message || erro;
    });
  }

  fecharLoja99Food(): void {
    if (!this.integracaoFood99) return;
    this.ativando = true;
    this.empresaService.fecharLoja99Food({ id: this.integracaoFood99.id }).then(() => {
      this.ativando = false;
      const info: any = this.infoLoja99Food();
      if (info) info.aberta = false;
      window.setTimeout(() => this.recarregueStatus99Food(), 800);
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro?.message || erro;
    });
  }

  private recarregueStatus99Food() {
    try { window.location.reload(); } catch (e) {}
  }

  infoLoja99Food(): any {
    try {
      if (!this.integracaoFood99) return null;
      const id = Number(this.integracaoFood99.id);
      return (this.monitoradorPedidos?.lojas99Food || []).find((l: any) => Number(l.id) === id);
    } catch (e) { return null; }
  }

  estaAberta99Food(): boolean | null {
    const info = this.infoLoja99Food();
    return info ? !!info.aberta : null;
  }

  estaDesconectada99Food(){
    const info = this.infoLoja99Food();

    return  info ? info.desconectada : null
  }

  statusMensagem99Food(): string | null {
    const info = this.infoLoja99Food();
    return info ? (info.mensagem || null) : null;
  }
}
